// CATCHPHRASE_POPUP_ENABLED (default on): the website's BOTCIERGE Catchphrase
// pop-up, light blue like the phone app's (PasskeyLoginModal). Typed in the chat
// box, a phone browser capitalised the first letter ("my phrase" -> "My
// phrase"), so a correct catchphrase failed on the first try. Here the box never
// capitalises, corrects or spell-checks, and the value is never shown in the chat.
import React, { useEffect, useRef, useState } from "react";

export default function CatchphraseModal({ open, email, busy, error, onSubmit, onCancel, onUseAnotherWay }) {
  const [value, setValue] = useState("");
  const [show, setShow] = useState(false);
  const inputRef = useRef(null);
  useEffect(() => {
    if (open) { setValue(""); setShow(false); setTimeout(() => inputRef.current && inputRef.current.focus(), 50); }
  }, [open]);
  if (!open) return null;
  const submit = (e) => {
    if (e) e.preventDefault();
    const v = value.trim();
    if (!v || busy) return;
    onSubmit(v);
  };
  return (
    <div role="dialog" aria-modal="true" aria-label="Enter your BOTCIERGE Catchphrase"
      style={{ position: "fixed", inset: 0, zIndex: 9800, background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}>
      <form onSubmit={submit}
        style={{ width: "min(380px, 100%)", background: "#eaf4fc", borderRadius: "18px", padding: "24px 20px 18px", boxShadow: "0 12px 40px rgba(0,0,0,0.35)", position: "relative", textAlign: "center", color: "#1d3b53" }}>
        <button type="button" onClick={onCancel} aria-label="Close" disabled={busy}
          style={{ position: "absolute", top: 10, right: 12, border: "none", background: "transparent", fontSize: "20px", color: "#4f8dbf", cursor: "pointer" }}>✕</button>
        <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#cfe5f6", margin: "0 auto 12px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "34px" }} aria-hidden="true">🔒</div>
        <div style={{ fontSize: "17px", fontWeight: 800, marginBottom: 6 }}>Enter your BOTCIERGE Catchphrase</div>
        <div style={{ fontSize: "13px", color: "#3f6684", marginBottom: 14 }}>{email ? `Log in to ${email} with your catchphrase.` : "Log in with your catchphrase."}</div>
        <div style={{ display: "flex", alignItems: "center", background: "#fff", border: "1.5px solid #9cc4e4", borderRadius: "10px", padding: "0 8px" }}>
          <input ref={inputRef} data-testid="catchphrase-input" type={show ? "text" : "password"} value={value} onChange={(e) => setValue(e.target.value)}
            autoCapitalize="off" autoCorrect="off" autoComplete="off" spellCheck={false} placeholder="Catchphrase" disabled={busy}
            style={{ flex: 1, border: "none", outline: "none", padding: "11px 4px", fontSize: "15px", background: "transparent", color: "#1d3b53" }} />
          <button type="button" onClick={() => setShow((s) => !s)} aria-label={show ? "Hide catchphrase" : "Show catchphrase"}
            style={{ border: "none", background: "transparent", color: "#4f8dbf", cursor: "pointer", fontSize: "13px", fontWeight: 700 }}>{show ? "Hide" : "Show"}</button>
        </div>
        {error && <div role="alert" style={{ color: "#c0392b", fontSize: "13px", marginTop: 8 }}>{error}</div>}
        <button type="submit" disabled={busy || !value.trim()}
          style={{ marginTop: 14, width: "100%", padding: "12px", borderRadius: "10px", border: "none", background: "#4f8dbf", color: "#fff", fontSize: "15px", fontWeight: 700, cursor: busy ? "wait" : "pointer", opacity: busy || !value.trim() ? 0.6 : 1 }}>
          {busy ? "Checking…" : "Log in"}
        </button>
        {onUseAnotherWay && (
          <button type="button" onClick={onUseAnotherWay} disabled={busy}
            style={{ marginTop: 10, border: "none", background: "transparent", color: "#4f8dbf", fontSize: "13px", fontWeight: 700, cursor: "pointer" }}>Use a different way</button>
        )}
      </form>
    </div>
  );
}
